<template>
	<v-container grid-list-md class="container--box">
		<app-head :title="$t('title.make_a_reservation')" />
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						{{ $t("title.make_a_reservation") }}
					</v-card-title>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<ReservationStepper
									:step="3"
									:outlet="outlet"
								></ReservationStepper>
							</v-flex>
							<v-flex xs12>
								<ReservationDetailForm
									v-model="item"
									:times="times"
								></ReservationDetailForm>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Submit") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>

<script>
import ReservationStepper from "@Reservation/components/ReservationStepper.vue";
import ReservationDetailForm from "@Reservation/forms/ReservationDetailForm.vue";
export default {
	components: {
		ReservationStepper,
		ReservationDetailForm,
	},
	props: ["outlet", "times"],
	data() {
		return {
			item: this.$inertia.form({
				outlet_id: this.outlet.id,
				adults: 1,
				children: 0,
				date: null,
				time: null,
				description: null,
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("reservation.reservations.store"));
		},
	},
};
</script>